<div class="form-wrapper">
  <app-form-container heading="Edit Merchant Information">
    <div class="form-group image-edit">
      <div class="image-container">
        <div class="merchant-logo">
          @if (logoBase64) {
            <img [src]="'data:image/png;base64,' + logoBase64" alt="Merchant Logo" class="logo-text" />
          } @else {
            <span class="logo-text">{{ logoText }}</span>
          }
        </div>

        <ng-container *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Update }">
          <div class="logo-edit" (click)="triggerLogoUpload()" style="cursor: pointer">
            <img class="edit-icon" [src]="'shared-assets/icons/edit.svg'" alt="Edit icon" />
            <p>Change Logo</p>
          </div>
        </ng-container>
      </div>

      <div class="status-buttons-container">
        <div class="form-actions button-container">
          @if (merchant.isSweepingEnabled) {
            <ng-container *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.DisableSweeping }">
              <app-button
                buttonVariant="status-wide"
                buttonType="button"
                [active]="!merchant.isSweepingEnabled"
                (buttonClick)="sweepingStatusUpdate()"
              >
                <mat-icon>cleaning_services</mat-icon>
                <span>Disable Sweeping</span>
              </app-button>
            </ng-container>
          } @else {
            <ng-container *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.EnableSweeping }">
              <app-button
                buttonVariant="status-wide"
                buttonType="button"
                [active]="!merchant.isSweepingEnabled"
                (buttonClick)="sweepingStatusUpdate()"
              >
                <mat-icon>cleaning_services</mat-icon>
                <span>Enable Sweeping</span>
              </app-button>
            </ng-container>
          }
        </div>

        <div class="form-actions button-container">
          @if (merchant.isActive) {
            <ng-container *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Disable }">
              <app-button
                buttonVariant="status"
                buttonType="button"
                [active]="!merchant.isActive"
                (buttonClick)="statusUpdate()"
              >
                <img class="status-icon" [src]="'shared-assets/icons/disable.svg'" [alt]="'Disable icon'" />
                <span>Disable</span>
              </app-button>
            </ng-container>
          } @else {
            <ng-container *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Enable }">
              <app-button
                buttonVariant="status"
                buttonType="button"
                [active]="!merchant.isActive"
                (buttonClick)="statusUpdate()"
              >
                <span>Activate</span>
              </app-button>
            </ng-container>
          }
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="text-input-wrapper disabled">
        <label>Merchant ID</label>
        <div class="text-input-container">
          <input type="text" [value]="merchant.code" disabled />
        </div>
      </div>
    </div>

    <div class="form-group">
      <form [formGroup]="editMerchantForm">
        <app-text-input
          [showCopyIcon]="false"
          [label]="'Merchant Name'"
          [placeholder]="merchant.name"
          formControlName="merchantName"
          [isInvalid]="getFieldError('merchantName', 'Merchant name') !== ''"
          [errorMessage]="getFieldError('merchantName', 'Merchant name')"
        />
      </form>
    </div>
    <div class="form-group">
      <form [formGroup]="editMerchantForm">
        <app-text-input
          [showCopyIcon]="false"
          [label]="'Merchant Callback URL'"
          [placeholder]="merchant.callbackUrl || 'Enter Callback URL'"
          formControlName="callbackURL"
          [isInvalid]="getFieldError('callbackURL', 'Merchant Callback URL') !== ''"
          [errorMessage]="getFieldError('callbackURL', 'Merchant Callback URL')"
        />
      </form>
    </div>

    <div class="form-group">
      <app-dropdown
        [label]="'Merchant Profile'"
        [placeholder]="merchant.profile ? merchant.profile.profileName : 'Select Merchant Profile'"
        [isInvalid]="false"
        [(ngModel)]="selectedMerchantProfile"
        [options]="merchantProfileOptions"
        [disabled]="!canEdit"
      />
    </div>

    <div class="form-group" *appHasPermission="{ resource: Resources.MerchantFeeProfiles, scope: Scopes.Access }">
      <app-dropdown
        [label]="'Merchant Fee Profile'"
        [placeholder]="merchant.feeProfile ? merchant.feeProfile.profileName : 'Select Merchant Fee Profile'"
        [isInvalid]="false"
        [(ngModel)]="selectedFeeProfile"
        [options]="feeProfileOptions"
        [disabled]="!canEdit || !canReadFeeProfiles"
      />
    </div>

    <div class="form-group">
      <app-dropdown
        [label]="'Merchant Risk Profile'"
        [placeholder]="merchant.riskProfile ? merchant.riskProfile.profileName : 'Select Merchant Risk Profile'"
        [isInvalid]="false"
        [(ngModel)]="selectedRiskProfile"
        [options]="riskProfileOptions"
        [disabled]="!canEdit"
      />
    </div>
    <div class="form-group">
      <form [formGroup]="editMerchantForm">
        <app-text-input
          [showCopyIcon]="false"
          [label]="'Merchant Supervisor Email'"
          [placeholder]="merchant.supervisorEmail || 'Enter Merchant Supervisor Email'"
          formControlName="supervisorEmail"
          [isInvalid]="getFieldError('supervisorEmail', 'Merchant Supervisor Email') !== ''"
          [errorMessage]="getFieldError('supervisorEmail', 'Merchant Supervisor Email')"
        />
      </form>
    </div>

    <div class="form-group">
      <form [formGroup]="editMerchantForm">
        <label class="custom-checkbox">
          <input type="checkbox" formControlName="isAssetFundingMerchant" [attr.disabled]="!canEdit ? '' : null" />
          <span class="checkmark"></span>
          Is Asset Funding Merchant
        </label>
      </form>
    </div>

    <div class="form-actions" *appHasPermission="{ resource: Resources.Merchants, scope: Scopes.Update }">
      <app-button
        buttonVariant="update-primary"
        buttonType="button"
        [state]="updateButtonState"
        (buttonClick)="onSubmit()"
      >
        Update
      </app-button>
    </div>
  </app-form-container>

  @if (isUploading) {
    <div class="loading-container">
      <app-loading-spinner size="large"></app-loading-spinner>
    </div>
  }
</div>
